import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {prettifyPrice} from '../../../helpers/prettifyFunctions';

const Summary = styled.div`
    padding: 2rem;
    box-shadow: ${p => p.theme.out};
    background: ${p => p.theme.low};
    border-radius: var(--smallRadius);
`;

const SummaryItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const SummarySeparator = styled.div`
    margin: 1rem 0;
    height: 0.2rem;
    width: 100%;
    background: ${p => p.theme.mid};
`;

const SummaryPrice = styled.div`
    display: flex;
    gap: 1rem;
    align-items: flex-start;
    justify-content: space-between;
`;

const SummaryText = styled.div`
    padding: 1rem;
    background: ${p => p.theme.mid};
    margin: 2rem 0 0;
    border-radius: var(--smallRadius);
    border-left: 0.4rem solid var(--focus);
`;

const currency_symbol = currency => currency === 'eur' ? '€' : currency;

export default function Summary_Sidequest(props) {

    const {t} = useTranslation();

    return (
        <Summary>
            <h3>{t('Price breakdown')}</h3>
            <SummarySeparator></SummarySeparator>
            <SummaryPrice>
                <p>{t('Price')}</p>
                <h5>{currency_symbol(props.currency)} {prettifyPrice(props.amount)}</h5>
            </SummaryPrice>
            <SummaryPrice>
                <p>{t('Tax')}</p>
                <h5>{currency_symbol(props.currency)} {prettifyPrice(props.tax)}</h5>
            </SummaryPrice>
            <SummarySeparator></SummarySeparator>
            <SummaryItem>
                <h4>{t('Payable now')}</h4>
                <h2>{currency_symbol(props.currency)} {prettifyPrice(props.total)}</h2>
            </SummaryItem>
            <SummaryText>
                <h5>{t('Billing cycle')}</h5>
                <p>{t('Your payment method will be charged automatically every month until you cancel.')}</p>
            </SummaryText>
        </Summary>
    );
}
